import React from 'react';
import ContestLanding from '../common/ContestLanding';
import VerticalLinearStepper from './VerticalLinearStepper';
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';

class ContestSteps extends ContestLanding {
  constructor(props) {
    super(props);
    this.state = {
      stepsLoaded:false,
      contestDataLoaded: false,
      registeredCount: false,
      pendingCount: false,
      countLoaded: false,
      forceUpdater: 0
    };
    this.dashboardDropDownKey = "homeDropdown";
    this.setChild(this,"CONTEST");

    this.contestSteps = null;
    this.currentStep = 0;

  }

  componentDidMount(){
    super.componentDidMount();
    this.getCount(this.loadSteps);  
  }


  getCount(callBack){
    let me = this;
    let success = (resp, opts) => {
      if(resp && resp.message === "success"){
        me.setState({countLoaded: true, registeredCount: (!isNaN(resp.registered) ? resp.registered : 0), pendingCount: (!isNaN(resp.pending) ? resp.pending : 0)});

        if(typeof callBack === "function"){
          callBack.apply(this);
        }
      }
    }

    let failure = (err, opts) => {
     console.error("Error occurred while trying to fetch count.");           
     if(typeof callBack === "function"){
      callBack.apply(this);
    }
  }

  if(!this.state.countLoaded){
    new HmAjax(this.getUrlFor("CONTEST_USERS_GET_COUNT").replace("{#contestId}",this.getSelectedContestGroup())).get(success, failure);
  }      
}

findCurrentStep(response){
  let currentTime = Math.round(new Date().getTime()/1000);

  try{
    if(currentTime >= response.resultDate){
     return 8;
   }else if(currentTime >= response.contestEndTime){
     return 7;
   }else if(currentTime >= response.contestStartTime){
     return 6;
   }else if(currentTime >= response.mockEndTime){
     return 6;
   }else if(currentTime >= response.mockStartTime){
     return 5;
   }else if(currentTime >= response.regnEndTime){
     return 4;
   }else if(this.state.registeredCount > 0){
     return 2;
   }else if(currentTime >= response.regnStartTime){
     return 1;
   }else if(currentTime >= response.earlyRegnEndTime){
     return 1;
   }else{
    return 1;
  }
}catch(e){
  console.error("Error occurred while finding the step :" , e);
  return 1;
}
}


loadCurrentStep(){
  let me = this;
  let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup().toUpperCase() : null;

  if(!contestId){
    return;
  }

  let success = (resp) => {
    if(resp && Object.keys(resp).length > 0){
     me.currentStep = me.findCurrentStep(resp);
     me.setState({stepsLoaded: true, forceUpdater:(me.state.forceUpdater++)});
   }
 }

 let failure = (err) => {
  console.error("Error occurred while getting loadCurrentStep : ", err);
}

new HmAjax(this.getUrlFor("GET_CONTEST_STEP_INFO").replace("{#contestId}",contestId)).get(success, failure);
}

loadSteps(){
  let me = this;
  let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup().toUpperCase() : null;

  if(!contestId){
    return;
  }

  let success = (resp) => {
    if(resp && resp.contest_steps){
     me.contestSteps = resp.contest_steps;

     me.setState({stepsLoaded: true});
     me.loadCurrentStep();
   }
 }

 let failure = (err) => {
  console.error("Error occurred while getting contest_steps from json : ", err);
}

new HmAjax(this.getUriFor("GET_CONTEST_STEPS_JSON").replace("CP_DOMAIN",this.getBasePath()).replace("{#contestId}",contestId)).get(success, failure);
}

render() {
  if(this.state.stepsLoaded){
    return super.render(
      <div className="HomeComponent">
      <VerticalLinearStepper currentStep={this.currentStep} steps={this.contestSteps}></VerticalLinearStepper>
      </div>
      )
  }else{
    return super.render(
      <div> {this.showLoader()} </div>
      )
    }
  }
}

export default ContestSteps;


// WEBPACK FOOTER //
// ./src/views/contest/ContestSteps.js